<template>
  <div class="bind_result_page">
    <div class="success-content" v-if="success">
      <div class="iconfont success-content_icon">&#xe6df;</div>
      <div class="c4 fs3">绑定成功</div>
      <div class="success-content_tips c9">
        <div>长按下面「小程序码」进行管理</div>
        <div>Tips: 在 发现 - 小程序，添加到「我的小程序」</div>
        <div>管理更方便</div>
      </div>
      <div class="success-content_qrcode">
        <img src="https://static.ibuole.com/public_file/img/tiyan_mini_QRcode.png" alt="">
      </div>
    </div>
    <div class="fail-content" v-else>
      <div class="iconfont fail-content_icon">&#xe627;</div>
      <div class="c4 fs3">绑定失败</div>
      <div class="c9 fail-content_subtitle">错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx错误原因：xxxxxxxxx</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    success() {
      return this.$route.params.type == 1 ? 1 : 0
    }
  },
  created() {
  }
}
</script>

<style lang='less'>
.bind_result_page {
  height: 100vh;
  padding-bottom: 70px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 2;
  .success-content {
    padding-bottom: 50px;
    &_icon {
      color: #56D176;
      font-size: 100px;
    }
    &_qrcode {
      width: 205px;
      height: 205px;
      margin: 30px auto 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .fail-content {
    padding-bottom: 200px;
    &_icon {
      color: lighten(#EC284D, 10%);
      font-size: 100px;
    }
    &_subtitle {
      padding: 0 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/clubAdmin/lampControl/bindResult.vue